<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-10">
            <br>
            <h3>Detalles del cliente</h3>

            <div class="row">
                <div class="col-lg-2">
                    <div *ngIf="perfil.imagen; else imagenPerfil">
                        <img src="{{environment}}{{perfil.imagen}}" width="100%"><br>
                    </div>
                    <ng-template #imagenPerfil>
                        <img src="assets/img/auri.png" width="100%"><br>
                    </ng-template>
                </div>
                <div class="col-lg-4">
                    {{perfil.nombre}} {{perfil.apellidos}}<br>
                    {{perfil.celular}} <br>
                    {{perfil.email}} <br>
                    {{perfil.grupo}} <br>
                    {{perfil.carrera}} <br>
                    <div *ngIf="perfil.solicitado == '0'">
                        Estatus de solicitud: <strong>Por solicitar</strong>
                    </div>

                    <div *ngIf="perfil.solicitado == '1'">
                        Estatus de solicitud: Solicitado
                        <button class="btn btn-danger" (click)="desolicitarCliente(perfil.id)">Desolicitar</button>
                    </div>
                     
                    <div *ngIf="perfil.estatus == 1">
                        <strong>Estatus: En compra</strong><br><br>
                        <button class="btn btn-success " (click)="updateEstatus(2, perfil.id)">Pasar a Producción</button>
                    </div>
                    <div *ngIf="perfil.estatus == 2"><strong>Estatus: En producción<br><br>
                    </strong></div>
                    <div *ngIf="perfil.estatus == 3"><strong>Estatus: Producido<br><br>
                        <button class="btn btn-success fondoAmarillo" (click)="updateEstatus(4, perfil.id)">Marcar como entregado</button>
                    </strong></div>
                    <div *ngIf="perfil.estatus == 4"><strong>Estatus: Entregado</strong></div><br><br>
                    
                </div>
               
                <div class="col-lg-6">
                    <span class="bold">Observaciones</span><br>
                    <div *ngFor="let observacion of observaciones">
                        <span>{{observacion.fecha}} - {{observacion.usuario}} - {{observacion.texto}} </span><br>
                    </div>
                </div>

               
            </div>
            
            

            <div class="row">
                <div class="col-lg-8">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item">
                          <a class="nav-link active" id="home-tab" data-toggle="tab" href="#paquetesTab" role="tab" aria-controls="paquetes-tab" aria-selected="true">Paquetes</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" id="profile-tab" data-toggle="tab" href="#placasTab" role="tab" aria-controls="placas-tab" aria-selected="false">Placas</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" id="messages-tab" data-toggle="tab" href="#marcosTab" role="tab" aria-controls="marcos-tab" aria-selected="false">Marcos</a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link" id="messages-tab" data-toggle="tab" href="#fondosMarcosTab" role="tab" aria-controls="fondosmarcos-tab" aria-selected="false">Fondos Marcos</a>
                          </li>

                        <li class="nav-item">
                          <a class="nav-link" id="settings-tab" data-toggle="tab" href="#coloresTab" role="tab" aria-controls="colores-tab" aria-selected="false">Colores</a>
                        </li>
        
                        <li class="nav-item">
                            <a class="nav-link" id="settings-tab" data-toggle="tab" href="#viajesTab" role="tab" aria-controls="viajes-tab" aria-selected="false">Viajes</a>
                        </li>
        
                        <li class="nav-item">
                            <a class="nav-link" id="settings-tab" data-toggle="tab" href="#fiestaTab" role="tab" aria-controls="fiesta-tab" aria-selected="false">Fiesta</a>
                        </li>
          
                        <li class="nav-item">
                            <a class="nav-link" id="settings-tab" data-toggle="tab" href="#anillosTab" role="tab" aria-controls="anillos-tab" aria-selected="false">Anillos</a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link" id="settings-tab" data-toggle="tab" href="#productosTab" role="tab" aria-controls="productos-tab" aria-selected="false">Productos Adicionales</a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link" id="settings-tab" data-toggle="tab" href="#dedicatoriasTab" role="tab" aria-controls="dedicatorias-tab" aria-selected="false">Dedicatorias</a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link" id="settings-tab" data-toggle="tab" href="#anotacionesTab" role="tab" aria-controls="anotaciones-tab" aria-selected="false">Anotaciones</a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link" id="settings-tab" data-toggle="tab" href="#pagosTab" role="tab" aria-controls="pagos-tab" aria-selected="false">Pagos</a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link" id="fotos-tab" data-toggle="tab" href="#fotosTab" role="tab" aria-controls="fotos-tab" aria-selected="false">Fotos</a>
                        </li>
                    </ul>
        
                    <div class="tab-content">
                        <div class="tab-pane active" id="paquetesTab" role="tabpanel" aria-labelledby="paquetes-tab">
                            <br>
                            <div class="row">
                                <div class="col-lg-3" *ngFor="let paquete of paquetesToChoose">
                                    <div *ngIf="paquete.imagen; else imagenAuri">
                                        <img src="{{environment}}{{paquete.imagen}}" width="100%">
                                    </div>
                                    <ng-template #imagenAuri>
                                        <img src="assets/img/auri.png" width="100%"><br>
                                    </ng-template>
                                    <p class="center">{{paquete.nombre}}
                                        <br><strong>${{paquete.precio}}</strong><br>
                                        <br>
                                            <i *ngIf="paquete.activo == 0">Inactivo</i>
                                        <br>
                                        <span (click)="getDetallePaquete(paquete.id)">Ver Detalles</span>
                                    </p>
                                    <div *ngIf="solicitado==0">
                                        <button class="fondoAmarillo border0 input90" (click)="agregarPaqueteCliente(paquete.id, clienteid)">Agregar Paquete</button><br><br>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <div class="tab-pane" id="placasTab" role="tabpanel" aria-labelledby="placas-tab">
                            <br>
                            <div class="row">
                                <div *ngFor="let placa of placas" class="col-lg-3">
                                    <div *ngIf="placa.imagen; else imagenAuri2">
                                        <img src="{{environment}}{{placa.imagen}}" width="100%"><br>
                                    </div>
                                    <ng-template #imagenAuri2>
                                        <img src="assets/img/auri.png" width="100%"><br>
                                    </ng-template>
        
                                    <p class="center">{{placa.nombre}}</p>
                                    <div *ngIf="solicitado==0">
                                        <button class="fondoAmarillo border0 input90" (click)="agregarPlaca(placa.id, clienteid)">Elegir Placa</button><br><br>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <div class="tab-pane" id="marcosTab" role="tabpanel" aria-labelledby="marcos-tab">
                            <br>
                            <div class="row">
                            <div *ngFor="let moldura of molduras" class="col-lg-3">
                                <div *ngIf="moldura.imagen; else imagenAuri4">
                                    <img src="{{environment}}{{moldura.imagen}}" width="100%">
                                </div>
                                <ng-template #imagenAuri4>
                                    <img src="assets/img/auri.png" width="100%"><br>
                                </ng-template>
        
                                <p class="center">{{moldura.nombre}}</p>
                                <div *ngIf="solicitado==0">
                                    <button class="fondoAmarillo border0 input90" (click)="agregarMoldura(moldura.id, clienteid)">Elegir Marco</button><br><br>
                                </div>
                            </div>
                            </div>
                        </div>
                        
                        <div class="tab-pane" id="fondosMarcosTab" role="tabpanel" aria-labelledby="fondosmarcos-tab">
                            <br>
                            <div class="row">
                            <div *ngFor="let fondoMarco of fondosMarcos" class="col-lg-3">
                                <div *ngIf="fondoMarco.imagen; else imagenAuri5">
                                    <img src="{{environment}}{{fondoMarco.imagen}}" width="100%">
                                </div>
                                <ng-template #imagenAuri5>
                                    <img src="assets/img/auri.png" width="100%"><br>
                                </ng-template>
        
                                <p class="center">{{fondoMarco.nombre}}</p>
                                <div *ngIf="solicitado==0">
                                    <button class="fondoAmarillo border0 input90" (click)="agregarFondoMolduraCliente(fondoMarco.id, clienteid)">Elegir Marco</button><br><br>
                                </div>
                            </div>
                            </div>
                        </div>

                        
                        <div class="tab-pane" id="coloresTab" role="tabpanel" aria-labelledby="colores-tab">
                            <br>
                            <div class="row">
                                <br>
                                <div *ngFor="let color of colores" class="col-lg-3">
                                    <div *ngIf="color.imagen; else imagenAuri3">
                                        <img src="{{environment}}{{color.imagen}}" width="100%">
                                    </div>
                                    <ng-template #imagenAuri3>
                                        <img src="assets/img/auri.png" width="100%"><br>
                                    </ng-template>
        
                                    <p class="center">{{color.nombre}}</p>
                                    <div *ngIf="solicitado==0">
                                        <button class="fondoAmarillo border0 input90" (click)="agregarColor(color.id, clienteid)">Elegir Color</button><br><br>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <div class="tab-pane" id="viajesTab" role="tabpanel" aria-labelledby="viajes-tab">
                            <br>
                            <div class="row" *ngFor="let viaje of viajes">
                                <div  class="col-lg-3">
                                    <img src="{{environment}}{{viaje.imagen}}" width="100%"><br>
                                    <br>
                                    
                                   
                                </div>
                                <div class="col-lg-6">
                                    <h5 class="center">{{viaje.nombre_viaje}}</h5>
                                    <p class="center">{{viaje.descripcion_viaje}}<br>
                                        <p class="center">Número máximo de lugares: {{viaje.numero_maximo_lugares}}<br>
                                    <span class="bold">Precio ${{viaje.precio_viaje}}</span></p>
                                    <div *ngIf="solicitado==0">
                                        <button class="fondoAmarillo border0 input90" (click)="agregarViaje(viaje.id_viaje, clienteid)">Agregar Viaje</button><br><br>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <div class="tab-pane" id="fiestaTab" role="tabpanel" aria-labelledby="fiesta-tab">
                            <br>
                            <div class="row" *ngFor="let fiesta of fiestas; index as i; ">
                                <div  class="col-lg-3">
                                    <img src="{{environment}}{{fiesta.imagen_fiesta}}" width="100%"><br>
                                    <br>
                                   
                                </div>
                                <div class="col-lg-6">
                                    <h5 class="center">{{fiesta.nombre_fiesta}}</h5>
                                    <p class="center">Máximo de boletos: {{fiesta.maximo_boletos}}<br>
                                        <p class="center">Máximo boletos niño:{{fiesta.maximo_boletos_nino}}<br>
                                    
                                    <span class="bold">Boleto Adulto: ${{fiesta.precio_boleto}}</span><br>
                                    <span class="bold">Boleto Niño: ${{fiesta.precio_boleto_nino}}</span></p>
                                    <div *ngIf="solicitado==0">
                                        <p class="center">
                                            Boletos Adulto:
                                            <input type="text" size="4" [(ngModel)]="boletos_adulto[i]" placeholder="10"> 
                                            <button class="fondoAmarillo border0 negro" (click)="agregarBoletosAdulto(clienteid, fiesta.fiesta_id, i);"> Agregar</button>   
                                        </p>
                                        
                                        <p class="center">
                                            Boletos Niño: 
                                            <input type="text" size="4" [(ngModel)]="boletos_nino[i]" placeholder="10"> 
                                            <button class="fondoAmarillo border0 negro" (click)="agregarBoletosNino(clienteid, fiesta.fiesta_id, i);"> Agregar</button>   
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <div class="tab-pane" id="anillosTab" role="tabpanel" aria-labelledby="anillos-tab">
                            <br>
                            <div class="row">
                                <div *ngFor="let anillo of anillos; let positionModeloAnillo=index" class="col-lg-3">
                                    <img src="{{environment}}{{anillo.imagen}}" width="100%"><br>
                                    <p class="center">{{anillo.nombre}} <br>
                                        <select [(ngModel)]="preciosAnilloIds[positionModeloAnillo]" (change)="selectAnillo(preciosAnilloIds[positionModeloAnillo])" class="form-control">
                                            <option value="0" selected>Selecciona tipo de anillo</option>
                                            <option *ngFor="let precioAnillo of precioAnillos; let position=index" [value]="precioAnillo.id">{{precioAnillo.metal}} 
                                                {{precioAnillo.gramaje}} {{precioAnillo.precio | currency}}</option>
                                        </select>
                                        <br>
                                        <select  [(ngModel)]="medidaAnillos[positionModeloAnillo]" class="form-control">
                                            <option value="0" selected>Selecciona medida de anillo</option>
                                            <option value="2">2</option>
                                            <option value="2.5" >2.5</option>
                                            <option value="3" >3</option>
                                            <option value="3.5" >3.5</option>
                                            <option value="4" >4</option>
                                            <option value="4.5" >4.5</option>
                                            <option value="5" >5</option>
                                            <option value="5.5" >5.5</option>
                                            <option value="6" >6</option>
                                            <option value="6.5" >6.5</option>
                                            <option value="7" >7</option>
                                            <option value="7.5" >7.5</option>
                                            <option value="8" >8</option>
                                            <option value="8.5" >8.5</option>
                                            <option value="9" >9</option>
                                            <option value="9.5" >9.5</option>
                                            <option value="10" >10</option>
                                            <option value="10.5" >10.5</option>
                                            <option value="11" >11</option>
                                            <option value="11.5" >11.5</option>
                                            <option value="12" >12</option>
                                            <option value="12.5" >12.5</option>
                                            <option value="13" >13</option>
                                            <option value="13.5" >13.5</option>
                                            <option value="14" >14</option>
                                        </select>
                                    <div *ngIf="solicitado==0">
                                        <button class="fondoAmarillo border0 input90" (click)="agregarAnilloCliente(anillo.id, clienteid, preciosAnilloIds[positionModeloAnillo], medidaAnillos[positionModeloAnillo])">Elegir Anillo</button><br><br>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane" id="productosTab" role="tabpanel" aria-labelledby="productos-tab">
                            <br>
                            <div class="row">
                                <div *ngFor="let producto of productos" class="col-lg-3">
                                    <div *ngIf="producto.imagen; else imagenAuri5">
                                        <img src="{{environment}}{{producto.imagen}}" width="100%">
                                    </div>
                                    <ng-template #imagenAuri5>
                                        <img src="assets/img/auri.png" width="100%"><br>
                                    </ng-template>
            
                                    <p class="center">{{producto.nombre}}
                                    <br><strong>${{producto.precio}}</strong><br></p>

                                    <div *ngIf="solicitado==0">
                                        <button class="fondoAmarillo border0 input90" (click)="agregarProductoCliente(producto.id, clienteid)">Elegir Producto</button><br><br>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane" id="dedicatoriasTab" role="tabpanel" aria-labelledby="dedicatorias-tab">
                            <br>
                            <p>Dedicatoria Personalizada:</p>
                            <span>Dirigiado a  (50 Caracteres máximo):</span><br>
                            <input type="text" [(ngModel)]="dedicatoriaPersonalizada.dirigido" maxlength="50" class="form-control"><br>
                            <textarea class="form-control" placeholder="Escribir Dedicatoria... (300 Caracteres Máximo)" maxlength="300" [(ngModel)]="dedicatoriaPersonalizada.texto"></textarea><br>

                            <div class="row">
                                <div class="col-lg-4">
                                    <button class="fondoAmarillo border0 input90" (click)="agregarDedicatoriaCliente('Personalizada', dedicatoriaPersonalizada.texto, dedicatoriaPersonalizada.dirigido, clienteid)">Agregar Dedicatoria</button><br><br><br>
                                </div>
                                <div class="col-lg-3"></div>
                                <div class="col-lg-3"></div>
                            </div>

                            <div class="row">
                                <div *ngFor="let dedicatoria of dedicatorias; let positionDedicatoriaAnillo=index" class="col-lg-3">
                                   
                                    <p class="center"><strong>{{dedicatoria.nombre}}</strong>
                                    <br>{{dedicatoria.texto}}<br></p>
                                    <!-- <span>Dirigiado a:</span><br>
                                    <input type="text"><br><br> -->
                                    <div *ngIf="solicitado==0">
                                        <button class="fondoAmarillo border0 input90" (click)="agregarDedicatoriaCliente(dedicatoria.nombre, dedicatoria.texto, dedicatoriaPersonalizada.dirigido, clienteid)">Elegir Dedicatoria</button><br><br>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane" id="fotosTab" role="tabpanel" aria-labelledby="fotos-tab">
                            <br>
                            <span class="bold">Agregar Foto:</span>
                            <div class="row">
                                <div class="col-lg-4">
                                    <input type="text" placeholder="Nombre Foto" [(ngModel)]="foto.nombre" class="form-control">
                                </div>
                                <div class="col-lg-4">
                                    <input (change)="imageChange($event.target.files)" type="file"accept="image/*" id="imagen2"><br>
                                </div>
                                <div class="col-lg-4">
                                    <button class="btn btn-success" (click)="agregarFoto();">Agregar</button>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-4" *ngFor="let fotoM of fotos">
                                    <br><br>
                                    <img src="{{environment}}{{fotoM.imagen}}" width="100%"><br>
                                    <p class="center bold">{{fotoM.nombre}}<br></p>

                                    <div class="row">
                                        <div class="col-lg-6">
                                            <button class="btn btn-danger" (click)="eliminarFoto(fotoM.id)">Eliminar</button>
                                        </div>
                                        <div class="col-lg-6">
                                            <p class="center">
                                                <button class="btn btn-success" (click)="descargarImagen(fotoM.imagen)">Descargar</button>
                                            </p>
                                        </div>
                                    </div>

                                   
                                </div>
                            </div>
                            
                        </div>



                        <div class="tab-pane" id="anotacionesTab" role="tabpanel" aria-labelledby="anotaciones-tab">
                            <br>
                            <span class="bold">Agregar Anotaciones</span><br>
                            <textarea placeholder="Anotaciones" class="form-control" [(ngModel)]="anotaciones.texto"></textarea><br>
                          <button class="btn btn-danger" (click)="agregarAnotaciones(clienteid)">Agregar</button><br>
                        </div>

                        <div class="tab-pane" id="pagosTab" role="tabpanel" aria-labelledby="pagos-tab">
                            <h2>Historial de Pagos</h2>

                            
                            <p>
                                <span *ngIf="datos_grupo.forma_pago == 1">Plan 1 50/50 <br></span>
                                <span *ngIf="datos_grupo.forma_pago == 2">Plan 2 30/30/40 <br></span>
                                <span *ngIf="datos_grupo.fecha_pago_uno">Fecha de pago 1: {{datos_grupo.fecha_pago_uno}}<br></span>
                                <span *ngIf="datos_grupo.fecha_pago_dos">Fecha de pago 2: {{datos_grupo.fecha_pago_dos}}<br></span>
                                <span *ngIf="datos_grupo.fecha_pago_tres">Fecha de pago 3: {{datos_grupo.fecha_pago_tres}}<br></span>
                                
                            </p>

                            <div class="row">
                                <!-- <div class="col-lg-3">
                                    <span class="bold">Fecha de Pago</span>

                                    <div class="input-group">
                                        <input id="fecha_pago_1" class="form-control"  [(ngModel)]="formulario.fecha" placeholder="Fecha de pago yyyy-mm-dd" name="dp1b" ngbDatepicker #dp1b="ngbDatepicker">
                                        <div class="input-group-append">
                                        <button class="btn btn-outline-secondary calendar" (click)="dp1b.toggle()" type="button">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                                            <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                                            </svg>
                                        </button>
                                        </div>
                                    </div>
                                    <br>
                                </div> -->
                                <div class="col-lg-3">
                                    <input type="text" class="form-control" placeholder="Folio" [(ngModel)]="formulario.folio">
                                </div>
                                <div class="col-lg-3">
                                    <input type="text" class="form-control" placeholder="Monto" [(ngModel)]="formulario.monto">
                                </div>
                                <div class="col-lg-3">
                                    <select #metodoPago class="form-control" [(ngModel)]="formulario.forma_pago">
                                        <option value="">Selecciona forma de Pago</option>
                                        <option value="Efectivo">Efectivo</option>
                                        <option value="Depósito Bancario">Depósito Bancario</option>
                                        <option value="Transferencia Electrónica">Transferencia Electrónica</option>
                                        <option value="Tarjeta de Crédito">Tarjeta de Crédito</option>
                                        <option value="Tarjeta de Débito">Tarjeta de Débito</option>
                                    </select>
                                </div>
                                <div class="col-lg-3">
                                    <select #metodoPago class="form-control" [(ngModel)]="formulario.tipo_pago">
                                        <option value="">Seleccione tipo de pago</option>
                                        <option value="Cuadros">Cuadros</option>
                                        <option value="Viaje">Viaje</option>
                                        <option value="Fiesta">Fiesta</option>
                                    </select>
                                </div>

                                <div class="col-lg-3">
                                    <br>
                                    <button class="btn btn-primary fondoAmarillo" (click)="agregarPago(usuarioid, metodoPago.value)">Agregar Pago</button>
                                </div>

                            </div>
                            <br>
                            <h5>Pagos Cuadros</h5>
                            <table class="table table-striped center">
                                <thead>
                                    <tr>
                                        <td>ID Pago</td>
                                        <td>Fecha</td>
                                        <td>Folio</td>
                                        <td>Monto</td>
                                        <td>Forma de Pago</td>
                                        <td>Tipo Pago</td>
                                        <td>Registró</td>
                                        <td>Recibo</td>
                                        <td *ngIf="datosCliente.acceso_pagos == 1">Eliminar</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let pagoC of pagosPorSegmento.pagosCuadros">
                                        <td>{{pagoC.id}}</td>
                                        <td>{{pagoC.fecha}}</td>
                                        <td>{{pagoC.folio}}</td>
                                        <td>{{pagoC.monto | currency}}</td>
                                        <td>{{pagoC.forma_pago}}</td>
                                        <td>{{pagoC.tipo_pago}}</td>
                                        <td>{{pagoC.registro}}</td>
                                        <td><a href="{{environment}}/api/reciboPago?pagoC={{pagoC.id}}" target="_blank">Ver Pago</a></td>
                                        <td *ngIf="datosCliente.acceso_pagos == 1"><button class="btn btn-danger" (click)="eliminarPago(pagoC.id, clienteid)">Eliminar</button></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="bold">Total</td>
                                        <td class="bold">${{pagosSegmentados.pagadoCuadros}}</td>
                                    </tr>
                                </tbody>
                            </table>


                            <br>
                            <h5>Pagos Viajes</h5>
                            <table class="table table-striped center">
                                <thead>
                                    <tr>
                                        <td>ID Pago</td>
                                        <td>Fecha</td>
                                        <td>Folio</td>
                                        <td>Monto</td>
                                        <td>Forma de Pago</td>
                                        <td>Tipo Pago</td>
                                        <td>Registró</td>
                                        <td>Recibo</td>
                                        <td *ngIf="datosCliente.acceso_pagos == 1">Eliminar</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let pagoV of pagosPorSegmento.pagosViaje">
                                        <td>{{pagoV.id}}</td>
                                        <td>{{pagoV.fecha}}</td>
                                        <td>{{pagoV.folio}}</td>
                                        <td>{{pagoV.monto | currency}}</td>
                                        <td>{{pagoV.forma_pago}}</td>
                                        <td>{{pagoV.tipo_pago}}</td>
                                        <td>{{pagoV.registro}}</td>
                                        <td><a href="{{environment}}/api/reciboPago?pagoV={{pagoV.id}}" target="_blank">Ver Pago</a></td>
                                        <td *ngIf="datosCliente.acceso_pagos == 1"><button class="btn btn-danger" (click)="eliminarPago(pagoV.id, clienteid)">Eliminar</button></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="bold">Total</td>
                                        <td class="bold">${{pagosSegmentados.pagadoViajes}}</td>
                                    </tr>
                                </tbody>
                            </table>


                            <br>
                            <h5>Pagos Fiesta</h5>
                            <table class="table table-striped center">
                                <thead>
                                    <tr>
                                        <td>ID Pago</td>
                                        <td>Fecha</td>
                                        <td>Folio</td>
                                        <td>Monto</td>
                                        <td>Forma de Pago</td>
                                        <td>Tipo Pago</td>
                                        <td>Registró</td>
                                        <td>Recibo</td>
                                        <td *ngIf="datosCliente.acceso_pagos == 1">Eliminar</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let pagoF of pagosPorSegmento.pagosFiesta">
                                        <td>{{pagoF.id}}</td>
                                        <td>{{pagoF.fecha}}</td>
                                        <td>{{pagoF.folio}}</td>
                                        <td>{{pagoF.monto | currency}}</td>
                                        <td>{{pagoF.forma_pago}}</td>
                                        <td>{{pagoF.tipo_pago}}</td>
                                        <td>{{pagoF.registro}}</td>
                                        <td><a href="{{environment}}/api/reciboPago?pagoF={{pagoF.id}}" target="_blank">Ver Pago</a></td>
                                        <td *ngIf="datosCliente.acceso_pagos == 1"><button class="btn btn-danger" (click)="eliminarPago(pagoF.id, clienteid)">Eliminar</button></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="bold">Total</td>
                                        <td class="bold">${{pagosSegmentados.pagadoFiesta}}</td>
                                    </tr>
                                </tbody>
                            </table>



                            <!-- <table class="table table-striped center">
                                <thead>
                                    <tr>
                                        <td>ID Pago</td>
                                        <td>Fecha</td>
                                        <td>Folio</td>
                                        <td>Monto</td>
                                        <td>Forma de Pago</td>
                                        <td>Tipo Pago</td>
                                        <td>Registró</td>
                                        <td>Recibo</td>
                                        <td *ngIf="datosCliente.acceso_pagos == 1">Eliminar</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let pago of pagos">
                                        <td>{{pago.id}}</td>
                                        <td>{{pago.fecha}}</td>
                                        <td>{{pago.folio}}</td>
                                        <td>${{pago.monto}}</td>
                                        <td>{{pago.forma_pago}}</td>
                                        <td>{{pago.tipo_pago}}</td>
                                        <td>{{pago.registro}}</td>
                                        <td><a href="{{environment}}/api/reciboPago?pago={{pago.id}}" target="_blank">Ver Pago</a></td>
                                        <td *ngIf="datosCliente.acceso_pagos == 1"><button class="btn btn-danger" (click)="eliminarPago(pago.id, clienteid)">Eliminar</button></td>
                                    </tr>
                                    <tr>
                                        <td class="bold">Total</td>
                                        <td class="bold">${{totalPagos}}</td>
                                    </tr>
                                </tbody>
                            </table> -->
                            
                            <br>
                            <h5>Total de pagos por segmento</h5>
                            <table class="table table-striped center">
                                <thead>
                                    <tr>
                                        <td>Concepto</td>
                                        <td>Monto</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Cuadros</td>
                                        <td>{{pagosSegmentados.pagadoCuadros | currency}}</td>
                                    </tr>
                                    <tr>
                                        <td>Viajes</td>
                                        <td>{{pagosSegmentados.pagadoFiesta | currency}}</td>
                                    </tr>
                                    <tr>
                                        <td>Fiestas</td>
                                        <td>{{pagosSegmentados.pagadoViajes | currency}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p class="center">Porcentaje de pago <strong>{{totalPagos/totalCliente*100 |number : '1.2-2'}}%</strong></p>
                            <p class="center">Saldo <strong>${{saldo}}</strong> de <strong>${{totalCliente}}</strong></p>



                            

                          
                           
                           
                    
                           
                    
                            
                            
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <app-mi-paquete></app-mi-paquete>
                </div>
                <div class="col-lg-1"></div>   
            </div>
            
            
        </div>
        
    </div>
</div>


<div id="clickPaquete" (click)="openModal(mymodal2)"></div>
<ng-template #mymodal2 let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{nombrePaquete}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="dismissAll()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body">
        <p>{{descripcion}}</p>

        <h5>Incluye:</h5>
        <img src="{{environment}}{{paqueteImagen}}" width="300px">
        <ul>
            <li *ngFor="let producto of detallePaquete">{{producto.nombre}}</li>
        </ul>
        
        <button class="btn btn-warning" (click)="agregarPaqueteCliente(paqueteid, clienteid)">Agregar</button>

    </div>
    <div class="modal-footer">
       

    </div>
  </ng-template>